import React, { useEffect, useState } from "react";
import {
  collection,
  query,
  where,
  getDocs,
} from "firebase/firestore";

import { db } from "../firebase";
import { useNavigate } from "react-router-dom";

import "./DepositCrypto.css";

/*
|--------------------------------------------------------------------------
| CRYPTO DEPOSIT METHODS
|--------------------------------------------------------------------------
*/

const DEPOSIT_METHODS = [
  {
    id: "TRC20",
    name: "Tether (USDT)",
    network: "TRC-20",
    coin: "USDT",
    field: "trc20Address",
    walletKey: "TRC20",
    min: 10,
    className: "deposit-usdt",
  },

  {
    id: "TRON_TRX",
    name: "Tron",
    network: "TRON",
    coin: "TRX",
    field: "trxAddress",
    walletKey: "TRON_TRX",
    min: 10,
    className: "deposit-trx",
  },

  {
    id: "ERC20",
    name: "Ethereum",
    network: "ERC-20",
    coin: "ETH",
    field: "erc20Address",
    walletKey: "ERC20",
    min: 10,
    className: "deposit-eth",
  },

  {
    id: "BNB_BEP20",
    name: "BNB Smart Chain",
    network: "BEP20 BSC",
    coin: "BNB",
    field: "bep20Address",
    walletKey: "BNB_BEP20",
    min: 10,
    className: "deposit-bnb",
  },

  {
    id: "BITCOIN",
    name: "Bitcoin",
    network: "BTC",
    coin: "BTC",
    field: "bitcoinAddress",
    walletKey: "BITCOIN",
    min: 10,
    className: "deposit-btc",
  },

  {
    id: "SOLANA",
    name: "Solana",
    network: "SOLANA",
    coin: "SOL",
    field: "solanaAddress",
    walletKey: "SOLANA",
    min: 10,
    className: "deposit-sol",
  },
];

/*
|--------------------------------------------------------------------------
| COIN LOGO
|--------------------------------------------------------------------------
*/

const CoinLogo = ({ type }) => {
  const common = {
    width: 42,
    height: 42,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
  };

  if (type === "USDT") {
    return (
      <svg {...common}>
        <circle cx="20" cy="20" r="18" fill="#26A17B" />

        <path
          d="M10 10.5H30V15H23V27.5H17V15H10V10.5Z"
          fill="white"
        />

        <path
          d="M20 15C25 15 29 16 29 17.5C29 19 25 20 20 20C15 20 11 19 11 17.5C11 16 15 15 20 15Z"
          fill="#26A17B"
        />

        <path
          d="M20 20V29"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
        />
      </svg>
    );
  }

  if (type === "TRX") {
    return (
      <svg {...common}>
        <circle cx="20" cy="20" r="18" fill="#EC1C24" />

        <path
          d="M10 10L30 13L22 30L10 10Z"
          fill="white"
        />

        <path
          d="M10 10L22 18L30 13"
          stroke="#EC1C24"
          strokeWidth="1.5"
        />

        <path
          d="M22 18L22 30"
          stroke="#EC1C24"
          strokeWidth="1.5"
        />
      </svg>
    );
  }

  if (type === "ETH") {
    return (
      <svg {...common}>
        <circle cx="20" cy="20" r="18" fill="#627EEA" />

        <path
          d="M20 6L12.5 20L20 24.5L27.5 20L20 6Z"
          fill="white"
        />

        <path
          d="M20 25.8L12.5 21.5L20 34L27.5 21.5L20 25.8Z"
          fill="white"
          opacity="0.7"
        />
      </svg>
    );
  }

  if (type === "BNB") {
    return (
      <svg {...common}>
        <circle cx="20" cy="20" r="18" fill="#F3BA2F" />

        <path
          d="M20 8L24 12L20 16L16 12L20 8Z"
          fill="#111827"
        />

        <path
          d="M13 15L16 18L13 21L10 18L13 15Z"
          fill="#111827"
        />

        <path
          d="M27 15L30 18L27 21L24 18L27 15Z"
          fill="#111827"
        />

        <path
          d="M20 15L25 20L20 25L15 20L20 15Z"
          fill="#111827"
        />

        <path
          d="M20 24L24 28L20 32L16 28L20 24Z"
          fill="#111827"
        />
      </svg>
    );
  }

  if (type === "BTC") {
    return (
      <svg {...common}>
        <circle cx="20" cy="20" r="18" fill="#F7931A" />

        <text
          x="20"
          y="27"
          textAnchor="middle"
          fontSize="22"
          fontWeight="900"
          fill="white"
          fontFamily="Arial"
        >
          ₿
        </text>
      </svg>
    );
  }

  if (type === "SOL") {
    return (
      <svg {...common}>
        <defs>
          <linearGradient
            id="solGradientCrypto"
            x1="5"
            y1="5"
            x2="35"
            y2="35"
          >
            <stop offset="0%" stopColor="#00FFA3" />
            <stop offset="100%" stopColor="#9945FF" />
          </linearGradient>
        </defs>

        <circle
          cx="20"
          cy="20"
          r="18"
          fill="#111827"
        />

        <path
          d="M10 13H29L25.5 16.5H10L13.5 13Z"
          fill="url(#solGradientCrypto)"
        />

        <path
          d="M11 19H30L26.5 22.5H11L14.5 19Z"
          fill="url(#solGradientCrypto)"
        />

        <path
          d="M10 25H29L25.5 28.5H10L13.5 25Z"
          fill="url(#solGradientCrypto)"
        />
      </svg>
    );
  }

  return null;
};

/*
|--------------------------------------------------------------------------
| DEPOSIT CRYPTO PAGE
|--------------------------------------------------------------------------
*/

export default function DepositCrypto() {
  const navigate = useNavigate();

  const [userData, setUserData] = useState(null);
  const [loadingUser, setLoadingUser] = useState(true);
  const [error, setError] = useState("");

  /*
  |--------------------------------------------------------------------------
  | LOAD USER
  |--------------------------------------------------------------------------
  */

  useEffect(() => {
    loadCurrentUser();
  }, []);

  const loadCurrentUser = async () => {
    try {
      setLoadingUser(true);
      setError("");

      const savedUsername =
        localStorage.getItem("username");

      if (!savedUsername) {
        setError("You are not logged in.");
        setLoadingUser(false);
        return;
      }

      const q = query(
        collection(db, "users"),
        where(
          "username",
          "==",
          savedUsername
        )
      );

      const snapshot = await getDocs(q);

      if (snapshot.empty) {
        setError("User account was not found.");
        setLoadingUser(false);
        return;
      }

      const userDoc = snapshot.docs[0];

      setUserData({
        id: userDoc.id,
        ...userDoc.data(),
      });

      setLoadingUser(false);
    } catch (err) {
      console.error(
        "Load user error:",
        err
      );

      setError(
        "Failed to load your account."
      );

      setLoadingUser(false);
    }
  };

  /*
  |--------------------------------------------------------------------------
  | GET EXISTING WALLET
  |--------------------------------------------------------------------------
  */

  const getExistingWalletAddress = (method) => {
    if (!method || !userData) {
      return "";
    }

    const oldAddress =
      userData?.[method.field];

    if (
      oldAddress &&
      String(oldAddress).trim()
    ) {
      return String(oldAddress).trim();
    }

    const walletAddress =
      userData?.cryptoWallets?.[
        method.walletKey
      ]?.address;

    if (
      walletAddress &&
      String(walletAddress).trim()
    ) {
      return String(walletAddress).trim();
    }

    return "";
  };

  /*
  |--------------------------------------------------------------------------
  | OPEN WALLET PAGE
  |--------------------------------------------------------------------------
  */

  const openWalletPage = (method) => {
    const existingAddress =
      getExistingWalletAddress(method);

    navigate("/BfcCryptoWallet", {
      state: {
        method,
        existingAddress,
      },
    });
  };

  /*
  |--------------------------------------------------------------------------
  | LOADING
  |--------------------------------------------------------------------------
  */

  if (loadingUser) {
    return (
      <div className="deposit-page">
        <div className="deposit-loading">
          <div className="deposit-spinner" />

          <p>
            Loading account...
          </p>
        </div>
      </div>
    );
  }

  /*
  |--------------------------------------------------------------------------
  | RENDER
  |--------------------------------------------------------------------------
  */

  return (
    <div className="deposit-page">

      <div className="deposit-container">

        {/* HEADER */}

        <div className="deposit-header">

          <button
            className="deposit-back-btn"
            type="button"
            onClick={() => navigate(-1)}
          >
            ←
          </button>

          <div className="deposit-title-wrap">

            <h1 className="deposit-title">
              Crypto Deposit
            </h1>

            <p className="deposit-subtitle">
              Choose your crypto deposit method
            </p>

          </div>

          <div className="deposit-security">

            <span className="deposit-security-dot" />

            Secure

          </div>

        </div>

        {/* ERROR */}

        {error && (
          <div className="deposit-alert deposit-error">

            <span>!</span>

            <p>
              {error}
            </p>

            <button
              type="button"
              onClick={() => setError("")}
            >
              ×
            </button>

          </div>
        )}

        {/* DEPOSIT METHODS */}

        <div className="deposit-method-list">

          {DEPOSIT_METHODS.map((method) => {

            const existingAddress =
              getExistingWalletAddress(method);

            return (
              <button
                key={method.id}
                type="button"
                className={`deposit-method ${method.className}`}
                onClick={() =>
                  openWalletPage(method)
                }
              >

                <div className="method-left">

                  <div className="method-icon">

                    <CoinLogo
                      type={method.coin}
                    />

                  </div>

                  <div className="method-info">

                    <strong>
                      {method.name}
                    </strong>

                    <span>
                      {method.network}
                    </span>

                  </div>

                </div>

                <div className="method-right">

                  <div>
                    Min: ${method.min}
                  </div>

                  {existingAddress && (
                    <span className="wallet-ready">
                      ✓ Wallet Ready
                    </span>
                  )}

                </div>

              </button>
            );
          })}

        </div>

      </div>

    </div>
  );
}
